export var GLOBAL = {
    //url: 'http://46.183.114.166:3789/api'
    //url: 'http://localhost:3789/api'
    //url: 'http://backend:3789/api'
    //url: 'http://104.238.235.164:3789/api'
    url: 'https://api.cybersecurityobservatory.org/api'
}

